/* eslint-disable no-console */

import { register } from "register-service-worker"

// VAPID public key
// let vapidPublicKey = "BFP_4-EuaAppMYFpan5dSoYWIh1Ag3beIyQwXslvBffELE6H81A5ZW29-L6NWjckMr4_at88RqDKgMjdtpyQ6XQ"

// Static cache name including version
let STATIC_CACHE_NAME = "static-v0.1"
// All static files to cache
let STATIC_FILES = [
  "/",
  "/index.html",
  "/favicon.ico",
  "/src/assets/jachal.me.png",
  "/public/img/favicon.ico"
]

// if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
        "For more details, visit https://goo.gl/AFskqB"
      )
    },
    registered() {
      // console.log(registration) // debug
      let perms = Notification.permission
      if (perms === 'default') {
        // request permissions
        // requestNotifyPerms()
      }
      console.log("Service worker has been registered.")
    },
    cached() {
      console.log("Content has been cached for offline use.")
    },
    updatefound(registration) {
      console.log(registration)

      caches.open(STATIC_CACHE_NAME)
        .then(function cacheStaticFiles(cache) {
          cache.addAll(STATIC_FILES)
        })

      console.log("New content is downloading.")
    },
    updated(registration) {
      console.log(registration)
      console.log("New content is available; please refresh.")
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.")
    },
    error(error) {
      console.error("Error during service worker registration:", error)
    }
  })
// }
/*
function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function requestNotifyPerms() {
  Notification.requestPermission(function(response) {
    if (response === 'granted') {
      showNotifyConfirm()
      configPushSub()
    }
  })
}
function showNotifyConfirm() {
  let options = {
    body: "Thank you for subscribing to our notification service.",
    icon: "favicon.ico"
  }
  navigator.serviceWorker.ready
    .then(function showNotify(swReg) {
      return swReg.showNotification("MyListingBot Subscription Service", options)
    })
  // new Notification("MyListingBot Subscription Service", options)
}

function configPushSub() {
  let reg
  navigator.serviceWorker.ready
    .then(function getPushSub(swReg) {
      reg = swReg
      return swReg.pushManager.getSubscription()
    })
    .then(function readPushSub(pushSub) {
      if (pushSub === null) {
        // create new subscription
        return reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
        })
      } else {
        console.log(pushSub)
      }
    })
    .then(function storePushSub(pushSub) {
      return fetch("http://localhost:3000/subscriptions/store/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(pushSub)
      })
    })
    .then(function confirmPushSub(response) {
      return response.json()
    })
    .then(function readResponse(response) {
      console.log(response)
    })
}
*/
